<div class="cerrix-dialog" [class]="setMaxWidth ? 'max-width' : ''" [attr.data-uiid]="dataUiid">
    <div class="cerrix-dialog-header">
        @if (data.icon) {
            <mat-icon class="cerrix-dialog-icon" [class]="data.iconClass">{{ data.icon }}</mat-icon>
        }
        @if (data.title) {
            <h2 class="cerrix-dialog-title" [attr.data-uiid]="dataUiid + '-title'">
                {{ data.title }}
            </h2>
        }
        <div
            mat-dialog-close
            class="cerrix-dialog-close"
            [attr.data-uiid]="dataUiid + '-close-button'"
        >
            <mat-icon>close</mat-icon>
        </div>
    </div>
    @if (statusMessage !== undefined) {
        <div class="cerrix-dialog-status">
            <span class="material-symbols-outlined fill" [class]="data.status">{{
                statusIcon
            }}</span
            ><span>{{ statusMessage }}</span>
        </div>
    }
    <div class="cerrix-dialog-body" [class.outlined]="data.negativeButton || data.positiveButton">
        @if (data.component) {
            <ng-template
                [cdkPortalOutlet]="portalRef"
                (attached)="componentInit($event)"
            ></ng-template>
        } @else {
            {{ data.message }}
        }
    </div>
    @if (data.negativeButton || data.positiveButton) {
        <div class="cerrix-dialog-footer">
            <div class="cerrix-dialog-footer-buttons align-right">
                @if (data.negativeButton) {
                    <button
                        mat-button
                        [class]="data.negativeButton.buttonClass"
                        [attr.data-uiid]="dataUiid + '-negative-button'"
                        (click)="close(data.negativeButton.onAction)"
                    >
                        {{ data.negativeButton.text }}
                    </button>
                }
                @if (data.positiveButton) {
                    <button
                        mat-button
                        [class]="data.positiveButton.buttonClass"
                        [attr.data-uiid]="dataUiid + '-positive-button'"
                        (click)="close(data.positiveButton.onAction)"
                    >
                        {{ data.positiveButton.text }}
                    </button>
                }
            </div>
        </div>
    }
</div>
